import BaseReducer from "../../utilities/BaseReducer";
import IAction from "../../models/IAction";
import ConfigurationAction from "./ConfigurationAction";
import IConfigurationState from "./models/IConfigurationState";
import ConfigurationModel from "./models/ConfigurationModel";

export default class ConfigurationReducer extends BaseReducer<IConfigurationState> {
    public readonly initialState: IConfigurationState = {
        getconfiguration: new ConfigurationModel({}),
    };

    public [ConfigurationAction.REQUEST_GET_CONFIGURAZIONE_FINISHED](
        state: IConfigurationState,
        action: IAction<ConfigurationModel>
    ): IConfigurationState {
        return {
            ...state,
            getconfiguration: action.payload!,
        };
    }
}
